import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { FilterContratistaModel } from 'src/app/models/contratista/FilterContratistaModel';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { IContratistaModel } from 'src/app/models/interfaces/contratista/IContratistaModel';
import { IFilterContratistaModel } from 'src/app/models/interfaces/contratista/IFilterContratistaModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-configuracion-contratista-lista',
  templateUrl: './configuracion-contratista-lista.component.html',
  styleUrls: ['./configuracion-contratista-lista.component.css']
})
export class ConfiguracionContratistaListaComponent implements OnInit {
  model!: SearchResultModel<IContratistaModel[]>;
  filter: IFilterContratistaModel = new FilterContratistaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;
  listaSedes: SedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  displayedColumns: string[] = [
    //'id',    
    'nombre',
    'ruc', 
    'companias',
    'estado',
    'acciones'
  ];
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(private serviceContratista: ContratistaService,
    private sedeService: SedeService,
    private companiaService: CompaniaService,
    private serviceParametros: ParametroService
    ) { 
    this.model = new SearchResultModel<IContratistaModel[]>(false, new Array<IContratistaModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_CONTRATISTA).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.serviceContratista.getListPaged(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });

    const filterSede: IFilterSedeModel = new FilterSedeModel();
    this.sedeService.getAllList(filterSede).subscribe((data: SedeModel[]) => {
      this.listaSedes = data;
    });

    const filterCompania: IFilterCompaniaModel = new FilterCompaniaModel();
    this.companiaService
      .getAllList(filterCompania)
      .subscribe((data: CompaniaModel[]) => {
        this.listaCompanias = data;
      });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceContratista
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceContratista
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
